import { OnPremHostnameDictionary } from '../interfaces/OnPremHostnameDictionary';

function getDealerByExperience(): string {
  const DealersExperience = sessionStorage.getItem('dealersExperience');
  switch (DealersExperience) {
    case 'hyundai':
      return process.env.REACT_APP_CMS_IA_DEALER_HYUNDAI_ONPREM_HOSTNAME;
    case 'acura':
      return process.env.REACT_APP_CMS_IA_DEALER_ACURA_ONPREM_HOSTNAME;
    case 'honda':
      return process.env.REACT_APP_CMS_IA_DEALER_HONDA_ONPREM_HOSTNAME;
    case 'genesis':
      return process.env.REACT_APP_CMS_IA_DEALER_GENESIS_ONPREM_HOSTNAME;
    default:
      return process.env.REACT_APP_CMS_IA_DEALER_UNIFI_ONPREM_HOSTNAME;
  }
}

export default function GetOnPremHostnameDictionary(): OnPremHostnameDictionary {
  const context: OnPremHostnameDictionary = {};

  context.client_0 = process.env.REACT_APP_CMS_IA_CLIENT_ONPREM_HOSTNAME;
  context.client_6 = process.env.REACT_APP_CMS_INVESTIA_CLIENT_ONPREM_HOSTNAME;
  context.advisor_0 = process.env.REACT_APP_CMS_IA_ADVISOR_ONPREM_HOSTNAME;
  context.advisor_6 = process.env.REACT_APP_CMS_INVESTIA_ADVISOR_ONPREM_HOSTNAME;
  context.client_14 = {};
  context.client_14.fr = process.env.REACT_APP_CMS_IAWEALTH_CLIENT_ONPREM_HOSTNAME_FR;
  context.client_14.en = process.env.REACT_APP_CMS_IAWEALTH_CLIENT_ONPREM_HOSTNAME_EN;
  context.dealer_0 = getDealerByExperience();
  context.partner_0 = process.env.REACT_APP_CMS_IA_PARTNER_ONPREM_HOSTNAME;
  return context;
}
